import React from "react";
import {components, GroupProps} from 'react-select';
import {EntryDesc} from 'generated/JavaTOmodifications'
import {ColorPairTO} from 'generated/JavaTO'

export function getEntryDescGroupStyles({typeCategoryColor}: { typeCategoryColor?: ColorPairTO }) {
	return {
		border: `2px solid #cccccc`,
		borderRadius: '5px',
		background: typeCategoryColor?.bgColor,
		color: typeCategoryColor?.textColor,
	}
}

export function EntryDescSelectGroup(props: GroupProps<EntryDesc, false>) {
	return <div style={getEntryDescGroupStyles(props.options[0])}>
		<components.Group {...props}/>
	</div>
}